import {AbstractService} from 'services/AbstractService';

const APP_CONFIG_URL = '/api/config';

export class ConfigService extends AbstractService {
  get () {
    return this.client.get(APP_CONFIG_URL);
  }
}
